import React from 'react'
import { useState, useEffect , useRef} from 'react'
import axios from 'axios'
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import Certificate from '../screens/Certificate'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useReactToPrint } from 'react-to-print';

const Reports = () => {
    const [moduleById, setModuleById] = useState([]);
    const[loading, setLoading] = useState(false)
    const [showPreview , setShowPreview] = useState(false);
    const [selectedModule, setSelectedModule] = useState(null)
  const user = JSON.parse(localStorage.getItem("userData"))
  const navigate = useNavigate()
  const pdfRef = useRef(null);

  const handleClickToOpen = (module) => {
    setSelectedModule(module);
    setShowPreview(true);
    console.log('Selected Module:', module);
};

const handleToClose = () => {
    setShowPreview(false);
};

const downloadCertficate = useReactToPrint({
  content : ()=> pdfRef.current,
  documentTitle : `${selectedModule?.event_name}.pdf`,
  })

// const  downloadCertficate = () => {
//   const element = pdfRef.current;
//   if(!element){
//     return;
//   }
//   html2canvas(element).then((canvas) => {
//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF('p', 'mm', 'a4', true);
//     const pdfWidth= pdf.internal.pageSize.getWidth();
//     const pdfHeight= pdf.internal.pageSize.getHeight();
//     const imageWidth = canvas.width;
//     const imageHeight = canvas.height;
//     const ratio = Math.min(pdfWidth / imageWidth, pdfHeight / imageHeight);
//     const imgx = (pdfWidth - imageWidth * ratio)/2;
//     const imgy = 0;
//     pdf.addImage(imgData,'PNG' , imgx, imgy, imageWidth * ratio, imageHeight * ratio);
//     pdf.save(`${selectedModule.event_name}.pdf`);
//   });
// };

  const fetchUserScoreCards = () => {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}api/v1/get-scores-by-id?id=${user?.id}`,
        {withCredentials : true}
      )
      .then((res) =>{ 
        console.log('resssss', res)
        setModuleById(res?.data?.data?.data)
        setLoading(false);
      })
        
      .catch((err) =>{ console.error(err)
      setLoading(false);
      });
  }

  console.log('module', moduleById)

  useEffect(() => {
    //     if (!token) {
    //       alert("You're not logged in");
    //       navigate("/login");
    // } else 
          fetchUserScoreCards();
      }, [])

      if(!user?.token){
        navigate('/login')
        return;
      }
      if(user?.role_id !== 2 ){
        navigate('/')
        return;
      }    

  return (
    <div className='font-pop relative'>
      <p className="font-semibold text-2xl mt-10 mx-5">Reports</p>
        <div className='flex flex-row lg:justify-start justify-center items-center p-4 gap-8 flex-wrap'>
        {loading?
          <div className='flex justify-center w-full mt-16'>
            <svg aria-hidden="true" className="inline w-7 h-7 text-primary animate-spin  fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
            </svg>
           </div>
          :
        moduleById?.length === 0
            ? <p className='mt-5 mx-1'>No Reports found!</p>
            :
            moduleById?.map((info, index) => (
             
              <div className='rounded-md w-[350px]  sm:h-[200px] shadow-md flex flex-col gap-2' key={index}>
                
              <p className='font-medium px-3 py-2 bg-primary rounded-t-md text-white capitalize'>{info?.module_name}</p>
              <div className='flex flex-col py-2 justify-around h-full text-[16px]'>
              <p className='px-3'><span className='font-medium'>Course Name: </span>{info?.event_name}</p>
              <p className=' px-3'><span className='font-medium'>Score : </span>{info?.score}</p>
              <div className='flex justify-between items-center px-3'>
                 <p className='font-medium'>Result : <span className={` font-normal ${info.result==='Pass'? 'text-green-500' : 'text-red-500'}`}>{info?.result}</span></p>
                 <button onClick={() => handleClickToOpen(info)} className={`bg-secondary px-2 py-1  text-white outline-none rounded-md text-sm ${info?.result !== 'Pass' && 'invisible'}`}>View Certificate</button>
             </div>
             </div>
              {/* <p className=' text-base'><span className=''>Completed On : </span>{info?.completed_at}</p> */}
              {/* {info?.result === 'Pass'  ? <button onClick={() => handleClickToOpen(info)} className='bg-black px-4 py-3 mr-2 my-2 text-white outline-0 border-0 rounded-md text-sm'>View Certificate</button> : ''} */}
             
          </div>
            ))
        }

        {
          showPreview && (
            <div className='fixed inset-0 z-50 flex justify-center items-center  bg-black bg-opacity-30 backdrop-blur-sm backdrop-filter'>
            <div className='relative bg-white scrollbar p-1 pt-0 w-[850px] h-[90%] overflow-y-auto rounded-md shadow-md '>
              <div className='sticky z-10 top-0 bg-white shadow-sm py-3 px-5  flex justify-between'>
                <button className='py-2 px-4 bg-secondary text-white rounded-md' onClick={downloadCertficate}>Download as PDF</button>
                <button className=' rounded-md py-2 px-4 text-secondary border border-secondary' onClick={handleToClose}>close</button>
            </div>
            <div className='mt-5 w-[794px] mx-auto'>
            <Certificate ref={pdfRef} module={selectedModule} />
            </div>
              </div>
          </div>
               
            
          )
        }
        
      </div>
    </div>
  )
}

export default Reports